<template>
  
  <div class="buy">
    
    <div class="container">

      <template v-if='step == 1'>
        
        <div>
          <b-card class="box-pin">
            <b-card-text class="box-modal">
              <h1 >¿Olvidaste tu contraseña?</h1>
              <p>Ingresa tu número de celular, te llegara un mensaje de texto con un pin para que puedas recuperar la contraseña.</p>

              <div class="form-group mt-3">
                <label>Celular</label>
                <input type="number" v-model="form.cellphone" class="form-control">
              </div> 
            </b-card-text>

            <button type="submit" class="mt-3 btn btn-space btn-primary w-100" v-on:click="sendPin()">Enviar</button>

          </b-card>
        </div>

      </template>

      <template v-if='step == 2'>
        <div>
          <b-card class="box-pin">
            <form v-on:submit.prevent="confirm()">

              <p class="center">Se envio un SMS con un PIN  a tu celular</p>
              <div class="form-group">
                <label>Pin:</label>
                <input type="text" v-model="process.resetToken" class="form-control">
              </div>

              <div class="form-group">
                <label>Nueva Contraseña:</label>
                <input type="password" v-model="process.newPassword" class="form-control">
              </div>

              <div class="form-group">
                <label>Repetir Contraseña:</label>
                <input type="password" v-model="process.verifyPassword" class="form-control">
              </div>

              <p class="center">Recuerda que la contraseña debe tener como mínimo 6 caracteres </p>

              <button type="submit" class="mt-3 btn btn-space btn-primary w-100">Validar</button>


            </form>
          </b-card>
        </div>
      </template>
    </div>

  </div>
</template>


<script>
import { mapGetters } from "vuex";
import { RECOVER_PASSWORD, RESTORE_PASSWORD } from "@/store/actions.type";

import AppFooter from "@/components/AppFooter.vue";

export default {
  components: {
    AppFooter
  },
  data: function() {
    return {
      step: 1,
      form: {},
      process: {}
    };
  },

  validations: {},

  mounted() {},
  methods: {
    sendPin() {
      this.$store
        .dispatch(RECOVER_PASSWORD, this.form)
        .then(result => {
          process;
          this.step = 2;
          this.form = {};
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    },

    confirm() {
      this.$store
        .dispatch(RESTORE_PASSWORD, this.process)
        .then(result => {
          this.$snotify.success(result.message);
          this.$router.push({ name: "dashboard" });
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    }
  },
  computed: {
    ...mapGetters([])
  }
};
</script>


<style lang="scss">
.box-pin {
  width: 50%;
  margin: 150px auto;

  h1 {
    color: #dab51b;
  }

  p {
    font-size: 18px;
  }

  .btn-send {
    // background: #dab51b;
    // border: none;
  }
}
</style>
